var _ellipse, _path, _circle, _path2, _ellipse2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path5, _path6, _path7, _path8, _path9, _path10, _circle2, _circle3, _circle4, _circle5, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoNav(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 55,
    viewBox: "0 0 191 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.9911,
    cy: 17.9354,
    rx: 15.1532,
    ry: 14.9354,
    fill: "#FFBA07"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.2493 32.8709C45.6097 32.8709 44.0556 32.8709 35.1817 32.8709C26.3078 32.8709 27.6268 32.8709 19.1141 32.8709C19.1141 28.7346 26.3078 25.3814 35.1817 25.3814C44.0556 25.3814 51.2493 28.7346 51.2493 32.8709Z",
    fill: "#2D2D2D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.946,
    cy: 15.7147,
    r: 0.870871,
    fill: "#09DE1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9573 27.3476C25.2528 26.9813 26.5602 26.5391 27.177 26.3637C24.373 23.8121 24.3044 17.6783 24.6206 14.9303C26.0741 15.2867 27.1951 19.397 27.5739 21.4076C28.1862 18.4168 26.987 15.4387 26.3109 14.3235C27.2665 13.3625 29.6707 13.7869 30.7533 14.1192C24.8778 10.3333 24.6753 12.7234 24.2614 12.2134C23.9302 11.8053 24.5424 10.966 24.89 10.5973C24.1418 10.6317 23.5249 11.483 23.3099 11.9044C23.0185 11.0008 21.54 10.7807 20.8372 10.7837C21.4672 10.8958 22.0316 11.8456 22.235 12.3065C17.3717 12.5302 16.726 14.7936 17.0111 15.8974C17.429 14.1147 20.7164 13.8166 22.3078 13.8904C19.3433 16.0018 20.4132 19.6795 21.3187 21.2544C21.3698 18.2894 22.7673 15.956 23.4596 15.16C22.6943 18.8986 24.5878 27.8054 24.9573 27.3476Z",
    fill: "#2D2D2D",
    stroke: "#2D2D2D"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.7748,
    cy: 15.2357,
    rx: 0.870871,
    ry: 0.914415,
    fill: "#09DE1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.054 22.6367C39.1564 20.06 42.3451 19.3189 44.9201 20.4254L51.1771 23.114C52.7969 23.8101 53.5458 25.6875 52.8497 27.3073V27.3073C52.1537 28.9272 50.2774 29.6765 48.6576 28.9805C44.9416 27.3837 38.907 24.7906 37.9966 24.3994C37.5554 24.2098 37.6845 23.5003 38.054 22.6367Z",
    fill: "#09DE1F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2553 20.4507C37.2582 20.0522 39.204 21.0542 39.204 21.0542L37.7598 24.4151L34.5001 23.0144C34.5001 23.0144 35.2523 20.8492 36.2553 20.4507Z",
    fill: "#09DE1F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.6145,
    y: 22.7111,
    width: 18.5686,
    height: 0.323871,
    transform: "rotate(23.2535 34.6145 22.7111)",
    fill: "#414141"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42.4263,
    y: 21.4853,
    width: 1.94323,
    height: 3.67054,
    transform: "rotate(23.2535 42.4263 21.4853)",
    fill: "#414141"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 40.0458,
    y: 20.4624,
    width: 1.94323,
    height: 2.05118,
    transform: "rotate(23.2535 40.0458 20.4624)",
    fill: "#414141"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 40.878,
    y: 24.815,
    width: 1.94323,
    height: 0.323871,
    transform: "rotate(23.2535 40.878 24.815)",
    fill: "#4B4848"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 40.6937,
    y: 24.9708,
    width: 1.94323,
    height: 0.323871,
    transform: "rotate(23.2535 40.6937 24.9708)",
    fill: "#4B4848"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 45.2036,
    y: 22.6787,
    width: 1.94323,
    height: 2.2671,
    transform: "rotate(23.2535 45.2036 22.6787)",
    fill: "#414141"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9349,
    y: 23.7532,
    width: 1.94323,
    height: 2.2671,
    transform: "rotate(23.2535 47.9349 23.7532)",
    fill: "#414141"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 50.5597,
    y: 24.9803,
    width: 1.94323,
    height: 2.2671,
    transform: "rotate(23.2535 50.5597 24.9803)",
    fill: "#414141"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 51.7747,
    y: 29.2624,
    width: 0.215914,
    height: 0.971613,
    transform: "rotate(23.2535 51.7747 29.2624)",
    fill: "#414141"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5087 24.7031L46.0673 24.5774",
    stroke: "#9B9B9B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1441 25.953L48.7028 25.8274",
    stroke: "#9B9B9B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6238 27.0186L51.1825 26.8929",
    stroke: "#9B9B9B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2546 23.6539L45.8132 23.5282",
    stroke: "#9B9B9B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9326 24.8046L48.4913 24.6789",
    stroke: "#9B9B9B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6107 25.9554L51.1694 25.8298",
    stroke: "#9B9B9B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5677,
    cy: 24.586,
    r: 1.45742,
    transform: "rotate(23.2535 38.5677 24.586)",
    fill: "#030303"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5677,
    cy: 24.586,
    r: 0.744903,
    transform: "rotate(23.2535 38.5677 24.586)",
    fill: "#BEBEBE"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.138,
    cy: 29.2457,
    r: 1.45742,
    transform: "rotate(23.2535 49.138 29.2457)",
    fill: "#030303"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.138,
    cy: 29.2457,
    r: 0.744903,
    transform: "rotate(23.2535 49.138 29.2457)",
    fill: "#BEBEBE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7628 33.809C23.1069 33.2659 29.6269 33.809 36.013 33.809C38.7521 33.809 41.6301 34.003 44.2823 34.003",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1021 36.549C20.4847 36.549 29.8757 36.3734 39.2313 37.0511",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8168 34.8739H48.8979",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2823 33.8289C47.173 33.4907 50.2392 33.3063 53.1652 33.3063",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7988 37.9006C46.0996 37.9006 51.4028 37.9566 56.7034 37.8872C57.0694 37.8825 58.3737 37.8846 58.9644 37.7806C59.1401 37.7497 58.6172 37.687 58.4409 37.6607",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5436 35.3093H30.5226",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M6.13818 34.2579C9.65667 34.2579 13.1752 34.2579 16.6937 34.2579C17.531 34.2579 18.9741 33.9867 19.7238 34.4384",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1472 40.4474C18.3582 40.1582 24.5656 40.0991 30.7838 40.0991",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M7.79279 36.5285C20.3368 36.7005 32.8666 36.8769 45.4144 36.8769",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M5.96399 39.4895H37.2283",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7117 35.3093C23.091 35.4001 34.4692 35.3964 45.8499 35.3964",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5436 36.2673C22.1489 36.7305 28.7699 37.0139 35.3907 37.0801C38.7404 37.1136 42.077 37.179 45.4145 37.4865",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6426 40.4475H39.2312",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M9.70874 36.0931C16.5211 37.1138 23.374 37.2253 30.2613 37.2253",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18622 32C11.5686 32.0179 13.9455 32.1742 16.3274 32.1742",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5285 38.0961C11.1419 38.5823 16.7589 38.3517 22.3363 39.2283",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M8.92493 44.7147H28.2583",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4504 39.925H55.9519",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8078 37.2253C48.5904 37.2044 50.2949 37.0375 52.033 36.7027",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2222 18.9369H38.7958",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1322 14.2343H38.4475",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1051 27.9069H16.9369",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8409 25.2943H14.4985",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6649 10.8047C30.7388 9.31925 32.0947 7.2925 32.8226 6.80708C39.1189 2.60824 44.8071 7.57165 45.972 9.95275C48.331 9.60323 48.7461 11.3071 48.615 13.0984C48.5102 14.5314 38.509 15.079 33.5216 15.1737C31.2324 15.3484 30.271 14.2453 30.0599 13.5972C30.0608 13.596 30.0617 13.5949 30.0627 13.5938C29.9985 13.4789 29.9151 13.3182 29.8083 13.0984C29.0558 11.5502 31.2353 10.8775 31.6649 10.8047Z",
    fill: "#00A3FF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8226 6.80708C32.0947 7.2925 30.7388 9.31925 31.6649 10.8047C31.2353 10.8775 29.0558 11.5502 29.8083 13.0984C30.5152 14.553 30.1965 13.4152 30.0599 13.5972C30.271 14.2453 31.2324 15.3484 33.5216 15.1737C38.509 15.079 48.5102 14.5314 48.615 13.0984C48.7461 11.3071 48.331 9.60323 45.972 9.95275C44.8071 7.57165 39.1189 2.60824 32.8226 6.80708Z",
    stroke: "#00A3FF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M2.98559 21.0321C2.07219 19.5595 3.40944 17.5504 4.12733 17.0692C10.337 12.9069 15.9469 17.8271 17.0958 20.1875C19.4224 19.841 19.8317 21.5301 19.7024 23.3058C19.599 24.7264 9.73551 25.2692 4.81668 25.3631C2.55905 25.5363 1.6109 24.4428 1.40266 23.8003C1.40356 23.7991 1.40447 23.798 1.40539 23.7969C1.34211 23.683 1.25985 23.5238 1.15449 23.3058C0.412428 21.7711 2.56192 21.1043 2.98559 21.0321Z",
    fill: "#00A3FF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12733 17.0692C3.40944 17.5504 2.07219 19.5595 2.98559 21.0321C2.56192 21.1043 0.412428 21.7711 1.15449 23.3058C1.8517 24.7478 1.53737 23.6199 1.40266 23.8003C1.6109 24.4428 2.55905 25.5363 4.81668 25.3631C9.73551 25.2692 19.599 24.7264 19.7024 23.3058C19.8317 21.5301 19.4224 19.841 17.0958 20.1875C15.9469 17.8271 10.337 12.9069 4.12733 17.0692Z",
    stroke: "#00A3FF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M60.664 9.432C61.5387 9.432 62.9253 9.38933 64.824 9.304C66.744 9.21867 68.4827 9.176 70.04 9.176C73.2827 9.176 75.5973 9.82667 76.984 11.128C78.3707 12.408 79.064 14.2 79.064 16.504C79.064 17.8907 78.584 19.1387 77.624 20.248C76.664 21.3573 75.4053 22.1893 73.848 22.744C74.7653 24.3013 75.6187 25.7627 76.408 27.128C77.2187 28.4933 77.8053 29.5067 78.168 30.168C78.5307 30.8293 78.8613 31.4267 79.16 31.96C79.4587 32.472 79.672 32.824 79.8 33.016C79.9493 33.208 80.088 33.368 80.216 33.496L82.52 33.816C82.6053 34.136 82.6053 34.5307 82.52 35H77.08L72.248 26.232C71.608 25.016 71 24.0773 70.424 23.416H69.976C68.888 23.416 67.7893 23.352 66.68 23.224V33.592L69.592 33.912C69.6773 34.232 69.6773 34.6267 69.592 35.096C68.248 35.032 66.7333 35 65.048 35C63.7893 35 62.264 35.0213 60.472 35.064C60.344 34.68 60.344 34.296 60.472 33.912L63.128 33.528C63.2133 32.7173 63.256 31.4693 63.256 29.784V10.936L60.664 10.616C60.5787 10.296 60.5787 9.90133 60.664 9.432ZM66.68 14.744V21.912C67.3413 21.9973 68.3013 22.04 69.56 22.04C70.648 22.04 71.576 21.8693 72.344 21.528C73.1333 21.1653 73.72 20.696 74.104 20.12C74.488 19.5227 74.7653 18.9147 74.936 18.296C75.1067 17.6773 75.192 17.0267 75.192 16.344C75.192 14.5093 74.7333 13.08 73.816 12.056C72.8987 11.032 71.3733 10.52 69.24 10.52C68.4507 10.52 67.6613 10.5947 66.872 10.744C66.744 11.96 66.68 13.2933 66.68 14.744ZM96.502 25.976H86.454C86.262 31.416 87.894 34.136 91.35 34.136C92.822 34.136 94.326 33.4853 95.862 32.184C96.182 32.376 96.4273 32.7067 96.598 33.176C95.126 34.8187 93.2593 35.64 90.998 35.64C85.7927 35.64 83.19 32.5787 83.19 26.456C83.19 23.5547 83.958 21.304 85.494 19.704C87.03 18.0827 88.822 17.272 90.87 17.272C93.11 17.272 94.7207 18.0507 95.702 19.608C96.6833 21.1653 97.174 23.192 97.174 25.688C96.9607 25.8587 96.7367 25.9547 96.502 25.976ZM90.806 18.552C89.6967 18.552 88.7473 19.128 87.958 20.28C87.19 21.432 86.7207 22.904 86.55 24.696H90.518C92.0967 24.696 93.2273 24.6 93.91 24.408C93.91 22.6587 93.6433 21.2507 93.11 20.184C92.5767 19.096 91.8087 18.552 90.806 18.552ZM105.187 25.784L111.875 19.32L109.763 19.064C109.677 18.7227 109.677 18.3067 109.763 17.816C110.936 17.9013 112.035 17.944 113.059 17.944C113.891 17.944 115 17.912 116.387 17.848C116.515 18.232 116.515 18.6373 116.387 19.064L113.859 19.512L108.195 24.824L115.171 33.176L117.667 33.816C117.752 34.1573 117.752 34.584 117.667 35.096C116.323 35.032 114.979 35 113.635 35C112.717 35 111.363 35.0213 109.571 35.064C109.443 34.6373 109.443 34.2213 109.571 33.816L111.683 33.528L105.187 25.784ZM104.835 14.712V33.368L107.427 33.848C107.512 34.1893 107.512 34.616 107.427 35.128C106.083 35.064 104.717 35.032 103.331 35.032C102.349 35.032 100.963 35.0533 99.1705 35.096C99.0425 34.6907 99.0425 34.2747 99.1705 33.848L101.699 33.496C101.784 32.3227 101.827 30.968 101.827 29.432V11.096L99.2025 10.776C99.1172 10.456 99.1172 10.0507 99.2025 9.56C100.632 9.45333 102.456 9.22933 104.675 8.888C104.867 9.10133 104.973 9.31466 104.995 9.528C104.888 10.0827 104.835 11.8107 104.835 14.712ZM119.352 9.432C120.44 9.432 122.008 9.38933 124.056 9.304C126.104 9.21867 127.458 9.176 128.12 9.176H128.984C131.778 9.176 133.858 9.752 135.224 10.904C136.589 12.0347 137.272 13.528 137.272 15.384C137.272 18.0293 135.544 19.864 132.088 20.888V20.984C134.093 21.2827 135.672 22.072 136.824 23.352C137.997 24.6107 138.584 26.1253 138.584 27.896C138.584 30.264 137.773 32.1093 136.152 33.432C134.552 34.7547 132.194 35.416 129.08 35.416C128.226 35.416 126.84 35.3413 124.92 35.192C123.021 35.064 121.506 35 120.376 35C120.248 35 120.045 35 119.768 35C119.49 35.0213 119.288 35.032 119.16 35.032C119.032 34.648 119.032 34.264 119.16 33.88L121.816 33.528C121.901 32.7173 121.944 31.4693 121.944 29.784V10.936L119.352 10.616C119.266 10.296 119.266 9.90133 119.352 9.432ZM127.928 22.008H125.368V33.592C126.456 33.784 127.32 33.9013 127.96 33.944C130.541 33.944 132.322 33.464 133.304 32.504C134.285 31.5227 134.776 29.9973 134.776 27.928C134.776 26.264 134.168 24.8667 132.952 23.736C131.757 22.584 130.082 22.008 127.928 22.008ZM128.152 10.52C127.085 10.52 126.2 10.5947 125.496 10.744C125.41 11.5547 125.368 12.888 125.368 14.744V20.408H127.864C129.848 20.408 131.288 20.0027 132.184 19.192C133.101 18.3813 133.56 17.176 133.56 15.576C133.56 13.9547 133.058 12.7067 132.056 11.832C131.074 10.9573 129.773 10.52 128.152 10.52ZM141.664 9.432C142.752 9.432 144.32 9.38933 146.368 9.304C148.416 9.21867 149.771 9.176 150.432 9.176H151.296C154.091 9.176 156.171 9.752 157.536 10.904C158.901 12.0347 159.584 13.528 159.584 15.384C159.584 18.0293 157.856 19.864 154.4 20.888V20.984C156.405 21.2827 157.984 22.072 159.136 23.352C160.309 24.6107 160.896 26.1253 160.896 27.896C160.896 30.264 160.085 32.1093 158.464 33.432C156.864 34.7547 154.507 35.416 151.392 35.416C150.539 35.416 149.152 35.3413 147.232 35.192C145.333 35.064 143.819 35 142.688 35C142.56 35 142.357 35 142.08 35C141.803 35.0213 141.6 35.032 141.472 35.032C141.344 34.648 141.344 34.264 141.472 33.88L144.128 33.528C144.213 32.7173 144.256 31.4693 144.256 29.784V10.936L141.664 10.616C141.579 10.296 141.579 9.90133 141.664 9.432ZM150.24 22.008H147.68V33.592C148.768 33.784 149.632 33.9013 150.272 33.944C152.853 33.944 154.635 33.464 155.616 32.504C156.597 31.5227 157.088 29.9973 157.088 27.928C157.088 26.264 156.48 24.8667 155.264 23.736C154.069 22.584 152.395 22.008 150.24 22.008ZM150.464 10.52C149.397 10.52 148.512 10.5947 147.808 10.744C147.723 11.5547 147.68 12.888 147.68 14.744V20.408H150.176C152.16 20.408 153.6 20.0027 154.496 19.192C155.413 18.3813 155.872 17.176 155.872 15.576C155.872 13.9547 155.371 12.7067 154.368 11.832C153.387 10.9573 152.085 10.52 150.464 10.52Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNav);
export default __webpack_public_path__ + "static/media/logoNav.a17c015308e62d723ec8440faae79e22.svg";
export { ForwardRef as ReactComponent };